import styled from 'styled-components'

export const TitleRowContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
`

export const TableTitle = styled.div`
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 3rem;
    margin-top: 20px;
    margin-bottom: 20px;

    @media (max-width: 1600px) {
        font-size: 2.5rem;
    }

    @media (max-width: 1200px) {
        font-size: 2rem;
    }

    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`

export const ActionWrapper = styled.div`
    display: flex;
    gap: 10px;
`
